(function(args) { 

	//paged fix
	jQuery('#form_projects_pagination .pagination .page-numbers').click(function(e){
	    e.preventDefault();  

	    var href = jQuery(this).attr('href');
	    jQuery('#form_projects_paged').val(href);

	  	var form = jQuery('#form_projects_pagination');
        
    	form[0].submit();	  	
		form.submit();
	});


})(args); 